import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderSlot as _renderSlot, withModifiers as _withModifiers, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "main-content",
  class: "ml-64 p-8"
}
const _hoisted_2 = {
  id: "page-header",
  class: "mb-8"
}
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_5 = {
  key: 1,
  id: "error",
  class: "mt-4 bg-red-100 border border-red-100 rounded-md p-6 mb-4"
}
const _hoisted_6 = { class: "flex items-start" }
const _hoisted_7 = { class: "space-y-2 mb-6" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "space-y-2 mb-2" }
const _hoisted_10 = { class: "relative" }
const _hoisted_11 = { class: "space-y-2 mb-2" }
const _hoisted_12 = { class: "relative" }
const _hoisted_13 = { class: "flex justify-end space-x-2 mt-5" }
const _hoisted_14 = {
  id: "users-table",
  class: "bg-white rounded-lg shadow-sm border border-gray-200"
}
const _hoisted_15 = {
  key: 0,
  class: "flex justify-center items-center h-32"
}
const _hoisted_16 = {
  key: 1,
  class: "overflow-x-auto"
}
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "bg-white divide-y divide-gray-200" }
const _hoisted_19 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_20 = { class: "flex items-center" }
const _hoisted_21 = { class: "text-sm font-medium text-gray-900" }
const _hoisted_22 = { class: "text-sm text-gray-500" }
const _hoisted_23 = { class: "px-6 py-4 whitespace-nowrap" }
const _hoisted_24 = {
  key: 0,
  class: "px-2 py-1 text-xs font-medium bg-red-100 text-red-800 rounded-full"
}
const _hoisted_25 = {
  key: 1,
  class: "px-2 py-1 text-xs font-medium bg-green-100 text-green-800 rounded-full"
}
const _hoisted_26 = {
  key: 2,
  class: "px-2 py-1 text-xs font-medium bg-indigo-100 text-indigo-800 rounded-full"
}
const _hoisted_27 = {
  key: 3,
  class: "px-2 py-1 text-xs font-medium bg-yellow-100 text-yellow-800 rounded-full"
}
const _hoisted_28 = { class: "px-6 py-4 whitespace-nowrap text-sm text-gray-500" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-right text-md font-medium" }
const _hoisted_30 = { class: "flex space-x-3" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "px-6 py-4 border-t border-gray-200" }
const _hoisted_35 = { class: "flex items-center justify-between" }
const _hoisted_36 = { class: "text-sm text-gray-700" }
const _hoisted_37 = { class: "font-medium" }
const _hoisted_38 = { class: "font-medium" }
const _hoisted_39 = {
  key: 0,
  class: "flex items-center space-x-2"
}
const _hoisted_40 = { class: "px-3 py-1 bg-blue-600 text-white rounded text-sm" }

import { onMounted, ref, computed } from 'vue';
import { useUserStore } from '@/store/users';
import { useNotificationStore } from '@/store/notifications';
import LottieAnimation from 'lottie-vuejs/src/LottieAnimation.vue';
import Header from '../components/header.vue';
import SideBar from '../components/sidebar.vue';
import Modal from '../components/modal.vue';
import UpdateUserModal from '../components/UpdateUserModal.vue';
import AssignPermissionModal from '../components/AssignPermissionModal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'users',
  setup(__props) {

const userStore = useUserStore();
const notificationStore = useNotificationStore();
const showModal = ref<boolean>(false);
const showEditModal = ref<boolean>(false);
const showPermissionModal = ref<boolean>(false);
const selectedUser = ref<any>(null);
const firstName = ref('');
const lastName = ref('');
const emailAddress = ref('');
const error = ref<string>('');
const loading = ref<boolean>(false);

const canManageUsers = computed(() => {
  const purpose = localStorage.getItem('purpose');
  if (purpose === 'local') return true;

  const permissions = localStorage.getItem('permissions');
  if (!permissions) return false;
  const permissionList = permissions.split(',').map((p) => p.trim().toLowerCase());
  return permissionList.includes('manage_users');
});

onMounted(() => {
  const purpose = localStorage.getItem('purpose');

  if (purpose === 'public') {
    userStore.fetchUsers(1);
  } else if (purpose === 'local') {
    userStore.fetchAdminUsers(1);
  }
});

function close() {
  userStore.error = null;
  showModal.value = false;
}

function formatDate(input: string) {
  const date = new Date(input);
  const formatted = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
  }).format(date);
  return formatted;
}

async function registerUser() {
  if (firstName.value === '' || lastName.value === '' || emailAddress.value === '') {
    notificationStore.showError('Validation Error', 'Please fill in all required fields.');
    return;
  }

  loading.value = true;
  try {
    const purpose = localStorage.getItem('purpose');

    if (purpose === 'public') {
      await userStore.registerUser(firstName.value, lastName.value, emailAddress.value);
    } else if (purpose === 'local') {
      await userStore.registerAdmin(firstName.value, lastName.value, emailAddress.value);
    }

    if (userStore.error) {
      notificationStore.showError('User Registration Failed', userStore.error);
    } else {
      notificationStore.showSuccess('User Created', 'New user has been registered successfully.');
      showModal.value = false;
      userStore.fetchUsers(1);
      firstName.value = '';
      lastName.value = '';
      emailAddress.value = '';
    }
  } catch (err) {
    notificationStore.showError('Registration Error', 'An unexpected error occurred during user registration.');
  } finally {
    loading.value = false;
  }
}

async function handleResetPassword(userId: string) {
  try {
    await userStore.resetPassword(userId);
    if (userStore.error) {
      notificationStore.showError('Reset Failed', userStore.error);
    } else {
      notificationStore.showSuccess('Password Reset', 'A new password has been sent to the user\'s email.');
    }
  } catch (err) {
    notificationStore.showError('Reset Error', 'An unexpected error occurred.');
  }
}

function editUser(user: any) {
  selectedUser.value = user;
  showEditModal.value = true;
}

function handleUserUpdated() {
  userStore.fetchUsers(1);
}

function managePermissions(user: any) {
  selectedUser.value = user;
  showPermissionModal.value = true;
}

function handlePermissionsUpdated() {
  // Permissions updated, no need to refresh user list
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Header),
    _createVNode(SideBar),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[19] || (_cache[19] = _createElementVNode("div", null, [
            _createElementVNode("h2", { class: "text-2xl font-bold text-green-800" }, "User Managment"),
            _createElementVNode("p", { class: "mt-2 text-gray-600 text-sm" }, "All users for your organization are found here")
          ], -1)),
          _createElementVNode("button", {
            id: "create-key-btn",
            class: "bg-green-800 hover:bg-green-700 text-white px-4 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showModal.value = true))
          }, _cache[10] || (_cache[10] = [
            _createElementVNode("i", { class: "fa-solid fa-user-plus mr-1" }, null, -1),
            _createElementVNode("span", null, "New User", -1)
          ])),
          _createVNode(Modal, {
            show: showModal.value,
            title: "Create new user",
            size: "max-w-4xl",
            onClose: _cache[7] || (_cache[7] = ($event: any) => (showModal.value =
          true))
          }, {
            default: _withCtx(() => [
              (loading.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, _cache[11] || (_cache[11] = [
                    _createElementVNode("div", { class: "animate-spin rounded-full h-10 w-10 border-b-2 border-green-600" }, null, -1)
                  ])))
                : _createCommentVNode("", true),
              (error.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("p", null, _toDisplayString(error.value), 1)
                    ])
                  ]))
                : _createCommentVNode("", true),
              (!loading.value)
                ? (_openBlock(), _createElementBlock("form", {
                    key: 2,
                    class: "space-y-6",
                    onSubmit: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (registerUser()), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[13] || (_cache[13] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "First Name", -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "text",
                          name: "text",
                          class: "block w-full pl-5 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                          placeholder: "John / Jane",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((firstName).value = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, firstName.value]
                        ]),
                        _cache[12] || (_cache[12] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "First name for the new user", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Last Name", -1)),
                      _createElementVNode("div", _hoisted_10, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "text",
                          name: "text",
                          class: "block w-full pl-5 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                          placeholder: "Doe",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((lastName).value = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, lastName.value]
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Last name for the new user", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_11, [
                      _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block text-sm font-medium text-gray-600" }, "Email Address", -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          id: "text",
                          name: "text",
                          class: "block w-full pl-5 pr-3 py-3 bg-white/10 border border-gray-500/20 rounded-sm border-gray-300 text-gray-600 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent",
                          placeholder: "jhon@example.com",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((emailAddress).value = $event)),
                          required: ""
                        }, null, 512), [
                          [_vModelText, emailAddress.value]
                        ]),
                        _cache[16] || (_cache[16] = _createElementVNode("p", { class: "text-gray-500 text-sm" }, "Email address for the new user. Please note that this is the username", -1))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _renderSlot(_ctx.$slots, "footer", {}, () => [
                        _createElementVNode("button", {
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (close())),
                          type: "button",
                          class: "px-4 py-1 bg-gray-300 rounded-sm hover:bg-gray-400",
                          onClose: _cache[5] || (_cache[5] = ($event: any) => (showModal.value = true))
                        }, " Close ", 32),
                        _cache[18] || (_cache[18] = _createElementVNode("button", { class: "bg-green-800 hover:bg-green-700 text-white px-6 py-3 rounded-md flex items-center space-x-2 font-medium text-white bg-gradient-to-r from-green-700 to-green-800 hover:from-green-700 hover:to-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 rounded-lg focus:ring-blue-500 transition-all duration-200 transform hover:scale-[1.02]" }, " Save ", -1))
                      ])
                    ])
                  ], 32))
                : _createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["show"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        (_unref(userStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(LottieAnimation, {
                path: "assets/images/loading.json",
                width: 150,
                height: 150
              })
            ]))
          : _createCommentVNode("", true),
        (!_unref(userStore).loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createElementVNode("table", _hoisted_17, [
                _cache[24] || (_cache[24] = _createElementVNode("thead", { class: "bg-gray-50" }, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "User"),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status"),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Created"),
                    _createElementVNode("th", { class: "px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Action")
                  ])
                ], -1)),
                _createElementVNode("tbody", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(userStore).users, (user) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      id: "user",
                      key: user.id
                    }, [
                      _createElementVNode("td", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _cache[20] || (_cache[20] = _createElementVNode("div", { class: "h-10 w-10 rounded-full bg-green-800 mr-3 p-3" }, [
                            _createElementVNode("i", { class: "fa-solid fa-user text-white items-center" })
                          ], -1)),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_21, _toDisplayString(user.firstName) + " " + _toDisplayString(user.lastName), 1),
                            _createElementVNode("div", _hoisted_22, _toDisplayString(user.emailAddress.String), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_23, [
                        (user.status === 'NOT_VERIFIED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Not Verified"))
                          : _createCommentVNode("", true),
                        (user.status === 'VERIFIED')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, "Verified"))
                          : _createCommentVNode("", true),
                        (user.status === 'ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Active"))
                          : _createCommentVNode("", true),
                        (user.status === 'INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Inactive"))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_28, _toDisplayString(formatDate(user.createdAt)), 1),
                      _createElementVNode("td", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (handleResetPassword(user.id)),
                            class: "text-amber-600 hover:text-amber-800",
                            title: "Reset Password"
                          }, _cache[21] || (_cache[21] = [
                            _createElementVNode("i", { class: "fa-solid fa-rotate-right" }, null, -1)
                          ]), 8, _hoisted_31),
                          (canManageUsers.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (editUser(user)),
                                  class: "text-green-600 hover:text-green-900",
                                  title: "Edit User"
                                }, _cache[22] || (_cache[22] = [
                                  _createElementVNode("i", { class: "fa-solid fa-edit" }, null, -1)
                                ]), 8, _hoisted_32),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (managePermissions(user)),
                                  class: "text-green-600 hover:text-green-900",
                                  title: "Manage Permissions"
                                }, _cache[23] || (_cache[23] = [
                                  _createElementVNode("i", { class: "fa-solid fa-key" }, null, -1)
                                ]), 8, _hoisted_33)
                              ], 64))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _cache[25] || (_cache[25] = _createTextVNode(" Showing ", -1)),
                    _createElementVNode("span", _hoisted_37, _toDisplayString(_unref(userStore).pagination.currentPage), 1),
                    _cache[26] || (_cache[26] = _createTextVNode(" of ", -1)),
                    _createElementVNode("span", _hoisted_38, _toDisplayString(_unref(userStore).pagination.totalPages), 1),
                    _cache[27] || (_cache[27] = _createTextVNode(" results ", -1))
                  ]),
                  (_unref(userStore).pagination.nextPage > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                        _cache[28] || (_cache[28] = _createElementVNode("button", {
                          class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-500 hover:bg-gray-50",
                          disabled: ""
                        }, "Previous", -1)),
                        _createElementVNode("button", _hoisted_40, _toDisplayString(_unref(userStore).pagination.nextPage), 1),
                        _cache[29] || (_cache[29] = _createElementVNode("button", { class: "px-3 py-1 border border-gray-300 rounded text-sm text-gray-700 hover:bg-gray-50" }, "Next", -1))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(UpdateUserModal, {
        show: showEditModal.value,
        user: selectedUser.value,
        onClose: _cache[8] || (_cache[8] = ($event: any) => (showEditModal.value = false)),
        onUserUpdated: handleUserUpdated
      }, null, 8, ["show", "user"]),
      _createVNode(AssignPermissionModal, {
        show: showPermissionModal.value,
        user: selectedUser.value,
        onClose: _cache[9] || (_cache[9] = ($event: any) => (showPermissionModal.value = false)),
        onPermissionsUpdated: handlePermissionsUpdated
      }, null, 8, ["show", "user"])
    ])
  ], 64))
}
}

})